<template>
  <div>
    <div class="select_area block">
      <el-row>
        <el-col :span="12">
          <span class="item_title">请选择地区：</span>
          <div style="width: 100%">
<!--            <el-cascader ref="cascader" :options="options" :props="{multiple:true,}" clearable v-model="area_selected" @change="handleChange"></el-cascader>-->
            <up-cascader ref="cascader" v-model="area_selected" :filterable="true"  :remote="false" :props="{multiple: true}"  :clearable="true"
                         :options="areaOptions"  @change="handleChangeArea" :maxCount="2" :myClass=" type== 1 ? 'cascader-instrument-area-tags' : 'cascader-instrument-area-tags2'"
                         :class=" type== 1 ? 'cascader-instrument-area-tags' : 'cascader-instrument-area-tags2'" placeholder="请选择地区" />
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="result_area block">
      <div>
        <div class="left" style="display: inline-block;width: 50%;">
          <span class="item_title">已选地区：</span>
          <el-checkbox v-model="checkedAllSelected" @change="handle_del_select_all()">全选</el-checkbox>
          <el-button @click="handle_delete()" size="mini" style="margin-left: 14px;background: #BD3124;color: #fff;border:none;">全部删除</el-button>
        </div>
        <div style="display: inline-block;width: 50%;text-align: right">
          <el-input v-model="key_word" size="mini" placeholder="请输入关键字" style="display: inline-block;width: 170px"></el-input>
          <el-button size="mini" @click="handle_filter" style="vertical-align: top;margin-left: 14px;background: #0052D9;color: #fff;">查找</el-button>
        </div>
      </div>
      <div class="tag_block">
      <div class="tag_list"  v-for="item in areaDisplayList">
        <span style="font-weight: bold;margin-right: 10px">{{item.province_name}}:</span>
        <span v-for="tag in item.city" :key="tag.value">
          <el-tag
              class="item_tag"
              :class="{ 'active-class': tag.isActive,}"
              effect="dark"
              @close="handleClose(tag)"
              closable>
            {{tag.label}}
          </el-tag>
        </span>
      </div>
      </div>
    </div>
    <el-dialog
        title=""
        :visible.sync="area_dialogVisible"
        width="30%"
        :modal="false"
        :modal-append-to-body="false"
        :before-close="handleCloseArea">
      <span>删除后不可恢复，确认要删除吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="area_dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmDeleteAll" style="background: #0052D9">确定删除</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import upCascader from "@/components/upCascader.vue";

export default {
  components: {upCascader},
  props:{
    type: {
      type: Number,
      default: 1
    },
    areaDataInfo:{
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      key_word: '', // 搜索的关键字
      areaOptions: [],  //下拉选项的数据
      props: { multiple: true }, // 多选的配置
      checkedAllSelected: false, // 已选地区全选（可能是筛选结果的全选），为了删除
      area_dialogVisible: false, //删除确认弹窗
      area_selected: [], //选中的区域，input绑定的值
      areaSelectOriginList: [], //选中的原始数据，可能不是展示数据，但是提交的原始数据
      areaSelectOriginListTemp: [], //选中的要展示的原始数据，主要为了区分筛选后的数据
      areaDisplayList: [], // 处理过最终展示的选中数据（可能是筛选过的，但不是提交的数据）
      areaSelectSubmitList: [], //处理过最终的提交数据
      hasAbroad: false, //是否有国外
    };
  },
  watch: {
    areaSelectOriginList (val) {

    },
    areaDataInfo(val){
      // console.log('areaDataInfo-jianting1111')
      if(val){
        this.initData()
      }

    }
  },
  mounted() {

    let originData = JSON.parse(localStorage.getItem('province'));
    // setTimeout(()=>{
      originData.forEach((item) => {
        if(item.city_list && item.city_list.length >0 ){
          item.children = []
          item.children = item.children.concat(item.city_list)
        }
      })
      this.areaOptions = originData
      // console.log('areaOptions-initData==',this.areaOptions)
    // },300)
  },
  methods: {

    initData(){
      if(this.areaDataInfo.length >0){
        let areaDataInfoTemp = this.areaDataInfo
        let listTemp = []
        areaDataInfoTemp.forEach((item) => {
          const parent = {
            label: item.province_name,
            value: item.province_id,
          }
          item.parent = parent

          // item.provinceName = item.province_name
          // item.provinceId = item.province_id
          // item.cityId = item.city_id
          // item.cityName = item.city_name
          item.city_list.forEach(i=>{
            i.parent = parent
            i.label = i.city_name
            i.value = i.city_id
            listTemp.push(i)

          })

        })

        // console.log('areaDataInfoTemp==',areaDataInfoTemp)
        this.areaSelectOriginList = listTemp
        this.areaSelectOriginListTemp = listTemp
        // 遍历 areaOptions，为每个 city_list 添加 disabled 属性
        const existCityIds = new Set(
            this.areaSelectOriginList.map(item => item.city_id)
        );
        this.areaOptions.forEach(province => {
          if (province.city_list && Array.isArray(province.city_list)) {
            province.city_list.forEach(city => {
              city.disabled = existCityIds.has(city.value);
            });
          }
        });
        // console.log('areaSelectOriginListTemp-initdata==',this.areaSelectOriginListTemp)
        this.rebuildDisplayData()
        this.rebuildSubmitData()
      }else{
        this.areaOptions.forEach(province => {
          if (province.city_list && Array.isArray(province.city_list)) {
            province.city_list.forEach(city => {
              city.disabled = false
            });
          }
        });
      }
    },
    rebuildDisplayData(){
      const area_display = [];    //展示的数据
      const provinceMap = {};
      this.hasAbroad = this.areaSelectOriginListTemp.some(item => item.value === 0);
      this.areaSelectOriginListTemp = this.areaSelectOriginListTemp.filter(item => {return item.parent != null })
      this.areaSelectOriginListTemp.forEach(item => {
        const { parent: { value: provinceId , label: provinceName  }, value: cityId, label: cityName } = item;
        // 处理 area_permission 数组
        if (!provinceMap[provinceId]) {
          provinceMap[provinceId] = [];
        }
        provinceMap[provinceId].push(cityId);
        // 处理 area_display 数组
        if (!area_display.some(province => province.province_id === provinceId)) {
          area_display.push({
            province_id: provinceId,
            province_name: provinceName,
            city: []
          });
        }
        const provinceIndex = area_display.findIndex(province => province.province_id === provinceId);
        area_display[provinceIndex].city.push({ value: cityId, label: cityName });
      });
      // 输出结果以验证
      // console.log('area_display:', area_display);
      this.areaDisplayList = area_display;
    },
    rebuildSubmitData(){
      const area_permission = []; //提交的数据格式
      const provinceMap = {};
      // console.log(' this.areaSelectOriginListTemp999', this.areaSelectOriginList)
      this.areaSelectOriginList = this.areaSelectOriginList.filter(item => {return item.parent != null})
      this.areaSelectOriginList.forEach(item => {
        const { parent: { value: provinceId, label: provinceName }, value: cityId, label: cityName } = item;

        // 处理 area_permission 数组
        if (!provinceMap[provinceId]) {
          provinceMap[provinceId] = [];
        }
        provinceMap[provinceId].push(cityId);

      });
      // 将 provinceMap 转换为 area_permission 数组
      for (const [provinceId, cityIds] of Object.entries(provinceMap)) {
        area_permission.push({
          province_id: parseInt(provinceId),
          city: cityIds // 注意：这里原示例中有个错误，城市列表应该是 [381, 382] 而不是 [381, 381]
        });
      }
      // 输出结果以验证
      // console.log('area_permission:', area_permission);
      this.areaSelectSubmitList = area_permission;
      // console.log('areaSelectSubmitList===rebuild',this.areaSelectSubmitList)
    },
    handleChangeArea(value, selectedData) {
      // console.log('selectedData==',selectedData)

      setTimeout(() => {
        this.areaSelectOriginList = this.areaSelectOriginList.concat(selectedData)
        this.areaSelectOriginListTemp = this.areaSelectOriginListTemp.concat(selectedData)
        this.areaSelectOriginList = [...new Map(
            this.areaSelectOriginList
                .filter(item => item.parent !== null) // 第一步：先过滤掉 parent 为 null 的项
                .map(item => [item.label, item])      // 第二步：提取 label 作为 key
        ).values()];
        this.areaSelectOriginListTemp = [...new Map(
            this.areaSelectOriginListTemp
                .filter(item => item.parent !== null) // 第一步：先过滤掉 parent 为 null 的项
                .map(item => [item.label, item])      // 第二步：提取 label 作为 key
        ).values()];
        // this.areaSelectOriginList = Array.from(new Map(this.areaSelectOriginList.map(item => [item.label, item]))).map(item => item[1]) ;
        // this.areaSelectOriginListTemp = Array.from(new Map(this.areaSelectOriginListTemp.map(item => [item.label, item]))).map(item => item[1]) ;
       // console.log('areaSelectOriginListTemp==',this.areaSelectOriginListTemp)
        this.rebuildDisplayData()
        this.rebuildSubmitData()

        // console.log('areaSelectSubmitList===123',this.areaSelectSubmitList)
      },300)
    },
    handleClose(tag) { // 删除某一个选中地区
      console.log('tag',tag)
      console.log('this.areaOptions',this.areaOptions)

      this.areaSelectOriginListTemp = this.areaSelectOriginListTemp.filter(item => item.value !== tag.value)
      this.areaSelectOriginList = this.areaSelectOriginList.filter(item => item.value !== tag.value)
      // this.areaDisplayList = this.areaDisplayList.filter(item => item.value !== tag.value)
      // this.areaSelectSubmitList = this.areaSelectSubmitList.filter(item => item.value !== tag.value)
      this.area_selected =  this.area_selected.filter(subArray => subArray[1] !== tag.value)
      this.areaOptions.forEach(province => {
          province.city_list.forEach(city => {
            if (city.value === tag.value) {
            city.disabled = false
            }
          });
      });
      this.rebuildDisplayData()
      this.rebuildSubmitData()
    },
    handle_filter(){ // 筛选选中地区匹配关键字的结果
      this.areaSelectOriginListTemp =  this.areaSelectOriginList.filter(item => item.label.includes(this.key_word))
      this.rebuildDisplayData()
      // this.rebuildSubmitData()
    },
    handle_del_select_all(e){ //选择所有的
      // console.log('checkedAllSelected===',this.checkedAllSelected)
      if(this.checkedAllSelected){
        this.areaDisplayList.forEach(item =>{
          item.city.forEach(i =>{
            i.isActive = true
          })
        })
      }else{
        this.areaDisplayList.forEach(item =>{
          item.city.forEach(i =>{
            i.isActive = false
          })
        })
      }
      // console.log('this.displayList',this.displayList)
    },
    handle_delete(){
      this.area_dialogVisible = true
    },
    handleCloseArea(){ //取消全部删除
      this.area_dialogVisible = false

    },
    confirmDeleteAll(){ //确定全部删除
      this.area_dialogVisible = false
      this.area_selected = []
      this.areaSelectOriginList = []
      this.areaSelectOriginListTemp = []
      console.log('this.areaOptions',this.areaOptions)
      this.areaOptions.forEach(province => {
        if (province.city_list && Array.isArray(province.city_list)) {
          province.city_list.forEach(city => {
            city.disabled = false
          });
        }
      });
      console.log('this.areaOptions222',this.areaOptions)
      this.handle_delete_all()
    },
    handle_delete_all(){ // 删除展示区域选中的所有的
      if(this.key_word){
        const array1 = this.areaSelectOriginList
        const array2 = this.areaSelectOriginListTemp
        this.areaSelectOriginList = array1.filter(item1 =>
            !array2.some(item2 => item2.value == item1.value)
        );
      }else{
        this.areaSelectOriginList = []
      }
      this.areaSelectOriginListTemp.forEach(item =>{
        this.area_selected =  this.area_selected.filter(subArray => subArray[1] !== item.value)
      })
      this.areaSelectOriginListTemp = []

      // console.log('this.areaSelectSubmitList456==',this.areaSelectSubmitList)
      this.checkedAllSelected = false
      this.$refs.cascader.handleClear()
      this.rebuildDisplayData()
      this.rebuildSubmitData()
    },
  }
};
</script>

<style scoped lang="scss">
.block{
  display: block;
  .item_title{
    display: inline-block;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 12px;
  }
}
.result_area{
  margin-top: 20px;
  border-radius: 5px;
  padding: 14px 12px;
  background-color: rgba(255,255,255,1);
  border: 1px solid rgba(239,239,239,1);
  .tag_block{
    max-height: 300px;
    overflow: auto;
  }
}
::v-deep .select_area .el-input__inner{
  width: 100%;
}
.result_area{
  margin-top: 20px;
}
.item_tag{
  margin:10px 14px 4px 0;
  background: #EFEFEF 50%;
  color: #4F4F4F;
  border:none;
  position: relative;
  ::v-deep .el-tag__close.el-icon-close{
    position: absolute;
    top: -8px;
    right: -8px;
    background: #BD3124;
  }
}
::v-deep .choose_distribute .el-input__inner{
  width: 100%;
}
::v-deep .item_tag.active-class{
  border: 1px solid #0052D9;
}
::v-deep .custom-select .el-tag {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::v-deep .result_area .el-input__inner{
  width: 100%!important;
}
</style>